import axiosInstance from "../../../helpers/api";

export const getAllRequests = (body) => {
  return axiosInstance.get("/superadmin/redo-exam-requests/unaccepted", body);
};

export const editRequests = (data) => {
  return axiosInstance.post(`superadmin/redo-exam-requests/accept`, data);
};

export const deleteRequest = (data) => {
  return axiosInstance.post(`/superadmin/redo-exam-requests/reject`, data);
};
